/**
 * Contact Form Block Fragment
 *
 * This fragment defines the fields queried for a contact-form-block.
 * It's used both for:
 * 1. Type generation (via CONTACT_FORM_BLOCK_QUERY)
 * 2. Composition into larger queries (via contactFormBlockFields)
 */

import { defineQuery } from 'next-sanity'
import { contactFormFields } from '../atoms'

/**
 * Field projection for contact-form-block
 * Can be interpolated into larger queries
 */
export const contactFormBlockFields = `
  _id,
  _type,
  title,
  "contactForm": contactForm->{
    ${contactFormFields}
  }
`

/**
 * Complete query for a single contact-form-block
 * Used by TypeGen to generate CONTACT_FORM_BLOCK_QUERY_RESULT type
 */
export const CONTACT_FORM_BLOCK_QUERY = defineQuery(/* groq */ `
  *[_type == "contact-form-block"][0]{
    ${contactFormBlockFields}
  }
`)
